import {FC} from 'react'
import clsx from 'clsx'
import {brandName, currentBrand} from '../brand'
import './AppLoading.css'

type AppLoadingProps = {
  message?: string
  detail?: string
  mode?: 'fullscreen' | 'overlay' | 'page'
}

const AppLoading: FC<AppLoadingProps> = ({
  message = `در حال آماده‌سازی ${brandName}…`,
  detail = 'لطفاً چند لحظه صبر کنید',
  mode = 'page',
}) => (
  <div
    className={clsx('mp-app-loading', `mp-app-loading--${mode}`)}
    role='status'
    aria-live='polite'
    aria-label={message}
  >
    <div className='mp-app-loading__panel'>
      <div className='mp-app-loading__mark' aria-hidden='true'>
        <span className='mp-app-loading__orbit' />
        <img src={currentBrand.mark || '/media/logos/default.svg'} alt='' />
      </div>
      <strong>{message}</strong>
      <small>{detail}</small>
      <div className='mp-app-loading__progress' aria-hidden='true'>
        <span />
      </div>
      <div className='mp-app-loading__dots' aria-hidden='true'>
        <i />
        <i />
        <i />
      </div>
    </div>
  </div>
)

export {AppLoading}
